<template>
  <div>
    <div class="flex flex-col lg:flex-row lg:items-center gap-10">
      <TImage
        :src="slide1Image"
        alt=""
        width="450"
        height="290"
        class="mx-auto"
      />

      <div>
        <THeading
          :level="2"
          tag="h2"
          class="mb-3"
        >
          {{ t('title') }}
        </THeading>

        <TBody variant="muted">
          {{ t('description') }}
        </TBody>
      </div>
    </div>

    <div class="grid lg:grid-cols-3 gap-6 my-12">
      <div>
        <THeading
          :level="5"
          tag="h3"
          class="mb-2"
        >
          {{ t('pickRV.title') }}
        </THeading>

        <TBody variant="muted">
          {{ t('pickRV.description') }}
        </TBody>
      </div>

      <div>
        <THeading
          :level="5"
          tag="h3"
          class="mb-2"
        >
          {{ t('findSpot.title') }}
        </THeading>

        <TBody variant="muted">
          {{ t('findSpot.description') }}
        </TBody>
      </div>

      <div>
        <THeading
          :level="5"
          tag="h3"
          class="mb-2"
        >
          {{ t('travelWithConfidence.title') }}
        </THeading>

        <TBody variant="muted">
          {{ t('travelWithConfidence.description') }}
        </TBody>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

const { getStaticImage } = useImage()
const slide1Image = computed(() => getStaticImage({
  path: '/web/images/custom-icons/discover-delivery/slide1.svg',
}))
</script>

<i18n lang="json">
  {
    "en": {
      "title": "Event-friendly RV delivery, made simple",
      "description": "Skip the pickup. Skip the towing. Get an RV delivered and set up at or near the event venue so you can arrive, unpack, and enjoy the event stress-free.",
      "pickRV": {
        "title": "Choose your perfect RV",
        "description": "Browse RVs that offer delivery for events and book the one that fits your budget and adventure style."
      },
      "findSpot": {
        "title": "Lock in your spot",
        "description": "Reserve your spot with the hookups and amenities you need. We’ll help you find RVs that meet site requirements."
      },
      "travelWithConfidence": {
        "title": "Arrive and relax",
        "description": "Your host delivers and sets up the RV before you get there. Just show up and start enjoying the event."
      }
    },
    "fr": {
      "title": "Livraison de VR pour les événements, simplifiée",
      "description": "Évitez le ramassage et le remorquage. Obtenez une livraison de VR et une installation sur le site ou à proximité de l'événement pour que vous puissiez arriver, défaire vos bagages et profiter de l'événement sans stress.",
      "pickRV": {
        "title": "Choisissez votre VR idéal",
        "description": "Parcourez les VRs qui offrent la livraison pour les événements et réservez celui qui correspond à votre budget et à votre style d'aventure."
      },
      "findSpot": {
        "title": "Réservez votre site",
        "description": "Réservez votre site avec les équipements et les commodités dont vous avez besoin. Nous vous aiderons à trouver des VRs qui répondent aux exigences du site."
      },
      "travelWithConfidence": {
        "title": "Arrivez et relaxez",
        "description": "Votre hôte livre et installe la VR avant votre arrivée. Il vous suffit de vous présenter et de commencer à profiter de l'événement."
      }
    }
  }
</i18n>
